import React from "react";
import MaterialReactTable from "material-react-table";
import { Loading } from "components";
import { useEmissionFactors } from "hooks";

export const ReferencesTable = ({
    referencesData,
    columns
}: {
    referencesData: any;
    columns: any
}) => {
    const { isLoading } = useEmissionFactors();
    return (
        <div>
            {isLoading ? (
                <Loading />
            ) : (
                <MaterialReactTable
                    columns={columns}
                    enableDensityToggle={false}
                    enableFullScreenToggle={false}
                    enableGlobalFilter={false}
                    muiTableContainerProps={{
                        sx: {
                            "& thead tr:nth-child(2)": {
                                "th:first-of-type": {
                                    paddingLeft: "20px",
                                },
                                "th > div > div > div": {
                                    whiteSpace: "nowrap",
                                }
                            },
                            "& tbody tr td:first-of-type": {
                                paddingLeft: "20px",
                            },
                            "& tbody tr:first-of-type td > p": {
                                display: "flex",
                                width: "100%",
                                justifyContent: "center",
                            },
                            height: "calc(100vh - 300px)",
                            border: "1px solid #D9D9D9",
                            borderRadius: "10px",
                            width: "100%",
                        },
                    }}
                    muiTablePaperProps={{
                        sx: {
                            borderRadius: "10px",
                            boxShadow: "none",
                        },
                    }}
                    muiTopToolbarProps={{
                        sx: {
                            height: '1px',
                            minHeight: '1px',
                            backgroundColor: 'transparent',
                            '& .MuiIconButton-root': {
                                display: 'none',
                            },
                        },
                    }}
                    muiBottomToolbarProps={{
                        sx: {
                            display: "none",
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            lineHeight: "30px",
                            "& .MuiBadge-root": {
                                display: "none",
                            },
                        },
                    }}
                    muiTableHeadRowProps={{
                        sx: {
                            "& > th": {
                                paddingTop: 1,
                                paddingBottom: 1,
                            },
                            height: "auto",
                            backgroundColor: "#F8FAFC",
                        },
                    }}
                    muiTableBodyRowProps={{
                        sx: {
                            height: "45px",
                            backgroundColor: "white",
                        },
                    }}
                    data={referencesData}
                    enableColumnResizing
                    initialState={{ density: "compact" }}
                    enablePagination={false}
                    enableRowVirtualization
                />
            )}
        </div>
    );
};
